import admin from '@Apis/admin.api';
import { CompanySettings } from '@innovyze/stylovyze';
import {
	CompanySettingsParams,
	CompanySettingsParamsWithCompanyId,
	CreateCompanySettingsParams,
} from '@Types/companySettings.types';

const baseEndpoint = '/settings';

export const getCompanySettingsByCompanyId = (
	companyId: string,
	params: CompanySettingsParamsWithCompanyId,
) => admin.get(`${baseEndpoint}/${companyId}`, { params });

export const getCurrentCompanySettings = (params: CompanySettingsParams) =>
	admin.get(`${baseEndpoint}`, { params });

export const getCompanySettings = (params: CompanySettingsParams) =>
	admin.get(baseEndpoint, { params });

export const createCompanySettings = (params: CreateCompanySettingsParams) =>
	admin.post(baseEndpoint, params);

export const updateCurrentCompanySettings = (
	params: Partial<CompanySettings>,
) => admin.patch(`${baseEndpoint}`, params);
